import { createContext } from 'react';
/**
 * The ValidationContext is used to pass down the `skipValidation` flag from the NBMRenderer
 * to any ReactRenderer nested inside a Legacy Content Macro. This allows the nested ReactRenderer
 * to bypass the ADF schema validation when necessary.
 */
export var ValidationContext = /*#__PURE__*/createContext(null);
export var ValidationContextProvider = ValidationContext.Provider;